var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "validation-observer",
    { ref: "rowDetailFormRef", attrs: { novalidate: "", tag: "form" } },
    [
      _c("div", { staticClass: "pt-3 pb-3 ml-2" }, [
        _c("div", { staticClass: "row ml-1 pl-1 my-3" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("icon-view", {
                attrs: {
                  icon: "fas fa-user-check",
                  "icon-background": "#fff",
                  "icon-color": "#3dbd8c",
                  "icon-size": "14px",
                  title: "Carga de Estudiante"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row ml-5 pl-1 my-3" }, [
          _c(
            "div",
            { staticClass: "col-md-4 col-sm-12" },
            [
              _c("div", { staticClass: "data-name mb-2" }, [
                _vm._v("Número de SIE:")
              ]),
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-input", {
                          attrs: {
                            "custom-error-msg": "",
                            error: errors[0],
                            fieldkey: "id",
                            fieldname: "name"
                          },
                          model: {
                            value: _vm.studentSieId,
                            callback: function($$v) {
                              _vm.studentSieId = $$v
                            },
                            expression: "studentSieId"
                          }
                        }),
                        errors[0]
                          ? _c("error", {
                              attrs: {
                                message: "Favor colocar número de SIE.",
                                variant: "no-border mt-1"
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4 mt-4 pr-5 pt-1" },
            [
              _c(
                "action-button",
                {
                  attrs: { i: "fas fa-redo-alt", variant: "success" },
                  on: { click: _vm.onSave }
                },
                [_vm._v(" Procesar ")]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }